import { Alert, Box, Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconAlertTriangle, IconCheck, IconX } from "@tabler/icons-react";
import { useState } from "react";

/** Xác nhận xóa (xóa mềm) các bản ghi đã chọn */
export const ConfirmDeleteView = ({
  message,
  onConfirm,
}: {
  message: string;
  onConfirm: () => Promise<void>;
}) => {
  const [loading, setLoading] = useState(false);

  return (
    <Box size={"auto"}>
      <Text size="20px" mt={5}>
        {message}
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
        <Button
          type="button"
          color="red"
          loading={loading}
          onClick={async () => {
            setLoading(true);
            await onConfirm();
            setLoading(false);
            modals.closeAll();
          }}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
      </Group>
    </Box>
  );
};

/** Danh mục còn tag (kể cả tag đã dừng sử dụng): backend chặn xóa, hướng người dùng xử lý tag trước */
export const BlockedDeleteCategoryView = ({
  categoryNames,
  tagCount,
  onViewTags,
}: {
  categoryNames: string[];
  tagCount: number;
  onViewTags: () => void;
}) => (
  <Box w={{ base: "300px", md: "400px" }}>
    <Alert
      variant="light"
      color="yellow"
      icon={<IconAlertTriangle size={20} />}
      mt={5}
    >
      <Text size="sm" c="dark">
        Danh mục{" "}
        {categoryNames.map((name, i) => (
          <Text span fw={700} key={name + i}>
            {i > 0 ? ", " : ""}“{name}”
          </Text>
        ))}{" "}
        còn {tagCount} tag. Hãy xóa các tag này hoặc chuyển sang danh mục khác
        trước khi xóa danh mục.
      </Text>
    </Alert>
    <Group justify="center" mt="md">
      <Button type="button" color="gray" onClick={() => modals.closeAll()}>
        Đóng
      </Button>
      <Button
        type="button"
        onClick={() => {
          modals.closeAll();
          onViewTags();
        }}
      >
        Xem tag của danh mục
      </Button>
    </Group>
  </Box>
);
